import React from 'react';
import { Box, Typography, Button, Container, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneIcon from '@mui/icons-material/Phone';

const included = ['Free Data Migration', 'Staff Training Included', 'Parent App Setup', 'Cloud Hosting', '24/7 Support', 'Custom Branding'];

const CTABanner = () => (
  <Box sx={{ background: 'linear-gradient(135deg, #0a0f2e 0%, #0d2060 45%, #1a5dad 100%)', py: { xs: 8, md: 10 } }}>
    <Container maxWidth="lg">
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={7}>
          <Typography sx={{ color: '#93c5fd', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 2, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>
            Modernize Your School Today
          </Typography>
          <Typography variant="h2" sx={{ color: '#fff', fontWeight: 900, mb: 3, fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.9rem', md: '3rem' }, lineHeight: 1.2 }}>
            200+ Schools Already Running Digitally. Join Them.
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: 17, mb: 4, fontFamily: "'Montserrat', sans-serif", lineHeight: 1.8 }}>
            Get full access — no hidden fees, no per-student pricing. One flat price for your whole institution.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Button variant="contained" size="large" sx={{ bgcolor: '#2563eb', px: 4, py: 1.6, borderRadius: '14px', fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: 15, boxShadow: '0 8px 32px rgba(37,99,235,0.5)', '&:hover': { bgcolor: '#1d4ed8' } }}>
              Request Free Demo
            </Button>
            <Button variant="outlined" startIcon={<PhoneIcon />} size="large" sx={{ borderColor: 'rgba(255,255,255,0.4)', color: '#fff', px: 4, py: 1.6, borderRadius: '14px', fontFamily: "'Montserrat', sans-serif", '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.06)' } }}>
              +91 97408 57368
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={5}>
          <Box sx={{ bgcolor: 'rgba(255,255,255,0.06)', borderRadius: '20px', p: 4, border: '1px solid rgba(255,255,255,0.12)' }}>
            <Typography sx={{ color: '#fff', fontWeight: 800, fontSize: '1.1rem', mb: 3, fontFamily: "'Montserrat', sans-serif" }}>Everything Included:</Typography>
            <Grid container spacing={1.5}>
              {included.map((item, i) => (
                <Grid item xs={6} key={i}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CheckCircleIcon sx={{ color: '#60a5fa', fontSize: 18 }} />
                    <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: 14, fontFamily: "'Montserrat', sans-serif" }}>{item}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default CTABanner;
